/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { API_PATH } from "src/environments/config";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DivisionService {
  public registrationObject;
  public divisions = [];
  public availableDivisions = [];
  public companyDetails;
  public isDivisionTimeEnabled = false;
  public selectedIndex = -1;
  public actualBusinessUnits = [];
  public newBooking = [];
  public sessionValue = 1;
  public sessionTimeOut: BehaviorSubject<any> = new BehaviorSubject({});
  constructor(private http: HttpClient, private router: Router) {}
  // Stage 1 for login
  generateOtpForLogin(data) {
    return this.http.post<any>(API_PATH.apis.loginWithOTP, data);
  }

  // Stage 2 for login
  verifyOtpForLogin(data) {
    return this.http.post<any>(API_PATH.apis.loginWithOTP, data);
  }

  // Stage 1 for registration
  generateOtpForRegistration(data) {
    return this.http.post<any>(API_PATH.apis.consumerRegister, data);
  }

  // Stage 2 for registration
  verifyOtpForRegistration(data) {
    return this.http.post<any>(API_PATH.apis.consumerRegister, data);
  }

  // Stage 3 for registration
  addConsumer(data) {
    return this.http.post<any>(API_PATH.apis.consumer, data);
  }

  // Stage 1 for confirmation
  generateConfirmActionOtp(data) {
    return this.http.post<any>(API_PATH.apis.confirmWithOtp, data);
  }

  // Stage 2 for confirmation
  validateConfirmActionOtp(data) {
    return this.http.post<any>(API_PATH.apis.confirmWithOtp, data);
  }

  // get consumer data
  getConsumer(data) {
    let httpParams = new HttpParams();
    httpParams = data.consumer
      ? httpParams.set("consumer", data.consumer)
      : httpParams;
    httpParams = data.company
      ? httpParams.set("company", data.company)
      : httpParams;
    httpParams = data.user ? httpParams.set("user", data.user) : httpParams;
    return this.http.get<any>(API_PATH.apis.consumer, { params: httpParams });
  }
  updateConsumerr(data) {
    return this.http.put<any>(API_PATH.apis.consumer, data);
  }
  getConsumerBookedAppointments(noBusUnit?) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("fromDate", "2021-03-01");
    httpParams = httpParams.set("toDate", "2027-04-07");
    httpParams = httpParams.set("isStatus", "Booked");
    httpParams = httpParams.set("myappointment", "true");
    if (!noBusUnit) {
      httpParams = httpParams.set(
        "businessUnitId",
        JSON.parse(sessionStorage.getItem("currentBusinessUnit"))._id
      );
    }
    return this.http.get<any>(API_PATH.apis.appointment, {
      params: httpParams,
    });
  }

  getConsumerCancelledAppointments(data) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("fromDate", data.fromDate);
    httpParams = httpParams.set("toDate", data.toDate);
    httpParams = httpParams.set("isStatus", "Cancelled");
    httpParams = httpParams.set("type", "slots");
    if (data.timeZone) {
      httpParams = httpParams.set("clientTimeZone", data.timeZone);
    }
    httpParams = httpParams.set(
      "businessUnitId",
      JSON.parse(sessionStorage.getItem("currentBusinessUnit"))._id
    );
    return this.http.get<any>(API_PATH.apis.businessUnitSlots, {
      params: httpParams,
    });
  }

  getAppointmentGroupById(appointmentGroup) {
    return this.http.get<any>(
      API_PATH.apis.updateAppointmentGroupData + appointmentGroup
    );
  }

  signInUser(data) {
    return this.http.post<any>(API_PATH.apis.signin, data);
  }

  getAvailableSlots(data) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("fromDate", data.fromDate);
    httpParams = httpParams.set("toDate", data.toDate);
    httpParams = httpParams.set("type", "slots");
    if (data.businessUnitId) {
      httpParams = httpParams.set("businessUnitId", data.businessUnitId);
    } else {
      httpParams = httpParams.set(
        "businessUnitId",
        JSON.parse(sessionStorage.getItem("currentBusinessUnit"))._id
      );
    }
    if (data.timeZone) {
      httpParams = httpParams.set("clientTimeZone", data.timeZone);
    }
    return this.http.get<any>(API_PATH.apis.businessUnitSlots, {
      params: httpParams,
    });
  }

  bookAppointment(data) {
    let orderLinkData = JSON.parse(localStorage.getItem("orderLinkData"));
    if (orderLinkData) {
      data.isPromotions = true;
      data.orderLinkData = orderLinkData;
    }
    return this.http.post<any>(API_PATH.apis.appointment, data);
  }

  getCompanyConfiguration(data) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("code", data);
    return this.http.get<any>(API_PATH.apis.configurationURL, {
      params: httpParams,
    });
  }

  createCallBack(data) {
    return this.http.post<any>(API_PATH.apis.callBack, data);
  }

  updateCallBack(data) {
    return this.http.put<any>(API_PATH.apis.callBack + "/" + data._id, data);
  }

  getCallBackList(data) {
    let httpParams = new HttpParams();
    if (data.currentPage)
      httpParams = httpParams.set("currentPage", data.currentPage);
    if (data.pageLimit)
      httpParams = httpParams.set("pageLimit", data.pageLimit);
    if (data.searchText)
      httpParams = httpParams.set("searchText", data.searchText);
    if (data.openState)
      httpParams = httpParams.set("openState", data.openState);
    if (data.closeState)
      httpParams = httpParams.set("closeState", data.closeState);
    if (data.currentBusinessUnit)
      httpParams = httpParams.set("businessUnit", data.currentBusinessUnit);
    return this.http.get<any>(API_PATH.apis.callBack, {
      params: httpParams,
    });
  }
}
